
import axios from 'axios'

export default {
    namespaced: true,
    state: {
        pedidos: [],
        conveniados: [],
        imagens: [],
        entradasEtapas: [],
        produtos: [],
        odontograma: [
            {
                superior: false,
                inferior: false,
                inferiores: [],
                superiores: [],
                dentesSelecionados: [],
            }
        ],

    },
    mutations:{
        STORE_PEDIDOS(state, result) {
            state.pedidos = result
        },
        STORE_ETAPAS(state, result) {
            state.entradasEtapas = result
        },
        STORE_CONVENIADOS(state, result) {
            state.conveniados = result
        },
        UPDATE_PEDIDOS(state, result) {
            let index = state.pedidos.findIndex( v => v.id === result.id)
            state.pedidos.splice(index, 1, result)
        },
        DELETE_PEDIDO(state, result) {
            let index = state.pedidos.findIndex( v => v.id === result.id)
            state.pedidos.splice(index, 1)
        },

        // IMAGENS

        STORE_IMAGENS(state, result) {
            state.imagens = result
        },
        ADD_IMAGENS(state, result) {

            result.forEach( (v) => {
                if(!state.imagens.hasOwnProperty(v.os_ficha_id)) {
                    Vue.set(state.imagens, v.os_ficha_id, [])
                }
                state.imagens[v.os_ficha_id].push(v)
            })
        },

        DELETE_IMAGENS(state, payload) {
            state.imagens[payload.id].splice(payload.index, 1)
        },

        // PRODUTOS

        STORE_PRODUTOS(state, result) {
            state.produtos = result
        },

        // ODONTOGRAMA


        STORE_ODONTOGRAMA(state) {
            state.odontograma.push(
                {
                    superior: false,
                    inferior: false,
                    inferiores: [],
                    superiores: [],
                    dentesSelecionados: [],
                }
            )
        },

        UPDATE_ODONTOGRAMA_SUPERIOR(state, result) {
            state.odontograma[result.index].superior = result.dados
        },
        UPDATE_ODONTOGRAMA_INFERIOR(state, result) {
            state.odontograma[result.index].inferior = result.dados
        },
        UPDATE_ODONTOGRAMA_INFERIORES(state, result) {
            state.odontograma[result.index].inferiores = result.dados
        },
        UPDATE_ODONTOGRAMA_SUPERIORES(state, result) {
            state.odontograma[result.index].superiores = result.dados
        },
        UPDATE_ODONTOGRAMA_SELECIONADOS(state, result) {
            state.odontograma[result.index].dentesSelecionados = result.dados
        },

    },
    getters: {
        conveniadosSemCadastroUsuario(state, result) {



        }
    },
    actions:{
        listaPedidos(context, filters){
            axios(`odontodocs/pedidos/${filters.laboratorioSelecionado}?mes=${filters.mes}&ano=${filters.ano}&tipo=${filters.tipo}&etapas=${filters.etapas}`).then( (res) => {
                context.commit('STORE_PEDIDOS', res.data.entrada)
                context.commit('STORE_IMAGENS', res.data.imagens)
                context.commit('STORE_ETAPAS', res.data.etapas)
                context.commit('STORE_PRODUTOS', res.data.produtos)
            })

        },
        listaConveniados(context, laboSelecionado){
            axios(`odontodocs/pedidos/conveniados/${laboSelecionado}`).then( (res) => {
                context.commit('STORE_CONVENIADOS', res.data)
            })

        },
    },

}
